import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { flexRender } from '@tanstack/react-table';
import Icon from '../../Icon';
import { Components as HeaderComponents } from './header.style';
const Header = _ref => {
  let {
    className,
    headerData,
    stickyHeader
  } = _ref;
  const handleTextAlign = header => {
    if ((header === null || header === void 0 ? void 0 : header.colSpan) > 1) {
      return 'center';
    }
    if ((header === null || header === void 0 ? void 0 : header.column.columnDef.type) === 'number') {
      return 'right';
    }
    return 'left';
  };
  const sortHeaderGroup = data => {
    const sortedHeader = data.sort((a, b) => a.column.columnDef.className === 'expander' || a.column.columnDef.className === 'selector' ? -1 : b.column.columnDef.className === 'expander' || b.column.columnDef.className === 'selector' ? 1 : 0);
    let leftPosition = 0;
    let rightPosition = 0;
    const rightPinnedItems = sortedHeader.filter(header => header.column.getIsPinned() === 'right');
    for (let i = rightPinnedItems.length - 1; i > 0; i--) {
      rightPosition += rightPinnedItems[i].getSize();
    }
    sortedHeader.forEach(header => {
      if (header.column.getIsPinned() === 'left') {
        header['left'] = leftPosition;
        leftPosition += header.getSize();
      }
      if (header.column.getIsPinned() === 'right') {
        header['right'] = rightPosition;
        rightPosition = rightPosition - header.getSize();
      }
    });
    return sortedHeader;
  };
  return _jsx(HeaderComponents.Thead, {
    children: headerData && headerData.map(headerGroup => _jsx("tr", _extends({
      className: "".concat(className, "-header")
    }, {
      children: sortHeaderGroup(headerGroup.headers).map(header => _jsx(HeaderComponents.Th, _extends({
        alignText: header.column.columnDef.alignData || handleTextAlign(header),
        className: "".concat(className, "-header-cell ").concat(header.column.id, " ").concat(header.column.getIsSorted() ? 'active' : ''),
        colSpan: header.colSpan,
        stickyColumn: header.column.columnDef.meta && header.column.columnDef.meta.stickyColumn,
        stickyHeader: stickyHeader || header.column.columnDef.meta && header.column.columnDef.meta.stickyColumn,
        left: header.left,
        right: header.right,
        width: header.column.columnDef.size
      }, {
        children: header.isPlaceholder ? null : _jsxs("div", _extends({}, {
          className: header.column.getCanSort() ? 'cursor-pointer' : '',
          onClick: header.column.getToggleSortingHandler()
        }, {
          children: [_jsx("span", {
            children: flexRender(header.column.columnDef.header, header.getContext())
          }), header.column.getIsSorted() ? header.column.getIsSorted() === 'desc' ? _jsx(Icon, {
            name: 'arrow-down'
          }) : _jsx(Icon, {
            name: 'arrow-up'
          }) : header.column.getCanSort() && _jsx(Icon, {
            name: 'arrows-down-up'
          })]
        }))
      }), header.id))
    }), headerGroup.id))
  });
};
export default Header;